module.exports = __webpack_public_path__ + "img/logo.52967a70.png";